import { h } from 'preact';

import { CollectiblesComponent } from '../../../content/components/collectibles/collectibles.component';

export const PerksCollectiblesComponent = () => {
  return (
    <div class="perks-collectibles-wrapper">
      <CollectiblesComponent
        loggedIn={true}
        showCollectibleTitle={true}
        showLogin={false}
        collectibleTitleSize="h2"
        collectibleTitleAlignment="left"
        textColor="#000000"
        buttonBackgroundColor="#000000"
        buttonTextColor="#FFFFFF"
        buttonBorderColor="#000000"
        hoverBackgroundColor="rgba(0, 0, 0, 0.7)"
        imageBorderColor="#000000"
        maxWidth={true}
        columns="4"
        imageBorderRadius="5px"
        buttonBorderRadius="5px"
        imageBorderWidth="1px"
        buttonBorderWidth="1px"
        horizontalPadding="16px"
        verticalPadding="20px"
      />
    </div>
  );
};
